import { useMemo } from 'react';
import { useTranslation } from '@shared/core';
import type { GuestNameRuleMessages } from '@shared/utils/guestName/guestName.types';

/** Error copy for the guest name rules (`isCsvSafeName`, `isSingleGuestName`), shared by every contact form that uses them. */
export const useGuestNameRuleMessages = (): GuestNameRuleMessages => {
  const { tq } = useTranslation('contactCollector');
  const csvUnsafe = tq`Names can’t contain commas, quotes or line breaks, or start with = + - @`;
  const multipleGuests = tq`Enter one person per name. Add the other person as an additional guest.`;
  return useMemo(() => ({ csvUnsafe, multipleGuests }), [csvUnsafe, multipleGuests]);
};
